import React, { PropsWithChildren, ReactNode, useState } from "react";

import { Button, IconButton } from "@material-ui/core";
import FilterListIcon from "@material-ui/icons/FilterList";

import { DialogWithActions } from "../";

export interface ActionFilterButtonWithDialogProps
  extends PropsWithChildren<any> {
  filterDialogTitle?: string;
  filterDialogActions?: ReactNode[];
  onConfirmClick: () => void;
}

function ActionFilterButtonWithDialog(
  props: ActionFilterButtonWithDialogProps
) {
  const {
    filterDialogTitle,
    filterDialogActions = [],
    onConfirmClick,
    children,
  } = props;

  const [filterDialogOpened, setFilterDialogOpened] = useState(false);

  const onFilterIconClick = () => setFilterDialogOpened(true);
  const onApplyClick = () => {
    onConfirmClick();
    setFilterDialogOpened(false);
  };

  return (
    <>
      <IconButton color="primary" onClick={onFilterIconClick}>
        <FilterListIcon />
      </IconButton>
      <DialogWithActions
        fullScreen={false}
        fullWidth={true}
        open={filterDialogOpened}
        setOpen={setFilterDialogOpened}
        actions={[
          ...filterDialogActions,
          <Button
            key="onApplyClick"
            onClick={onApplyClick}
            variant="outlined"
            color="primary"
          >
            Applica e chiudi
          </Button>,
        ]}
        title={filterDialogTitle ?? "Filtri"}
      >
        {children}
      </DialogWithActions>
    </>
  );
}

export { ActionFilterButtonWithDialog };
